import { useNavigate } from "react-router-dom";
import CardList from "../../components/styled/CardList";
import CardTitle from "../../components/styled/CardTitle";
import { arrayMap } from "../../utils/array.utils";
import { viewLoanFormatterFunc } from "../../utils/moneyReceipt.utils";

export default function CustomerLoanInformation({ data }) {
  const navigate = useNavigate();
  const loan = data?.customer?.loan;

  const handleView = (username) => {
    if (username) {
      navigate(`/user/${username}/profile`);
    }
  };

  const formattedData = viewLoanFormatterFunc(loan, { handleView });

  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Customer Loan</CardTitle>
        <CardList className="list-unstyled mb-0">
          {arrayMap(formattedData, (item, index) => (
            <li key={index}>
              <b>{item.label}</b>: {item.value}
            </li>
          ))}
        </CardList>
      </div>
    </div>
  );
}
